define(function(require) {

    const PROD_SERVER_URL = "https://infogeo.education.gouv.qc.ca",
          DEV_SERVER_URL = "https://carto48dev.education.gouv.qc.ca",
          SERVER = document.location.origin === PROD_SERVER_URL ? "PROD" : "DEV",
          QUERY_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/PUBLIC_QUERY_SERVICES/GPServer",
          LOGGER_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/LOGGER_SERVICES/GPServer",
          GEOCODER_MSP_URL = "https://geoegl.msp.gouv.qc.ca/apis/icherche/geocode";

    return {
        APP_NAME: "Atlas_Defavorisation",
        URLS: {
            LOGGER: {
                LOG_CLIENT_ERROR: LOGGER_SERVICES_URL + "/LogClientError/execute"
            },
            QUERY_LAYERS : {
                GEO09E45_UNI_PEUP_2008 : QUERY_SERVICES_URL + "/Query_GEO09E45_UNI_PEUP_2008/execute",
                GEO09E46_UNI_PEUP_2018 : QUERY_SERVICES_URL + "/Query_GEO09E46_UNI_PEUP_2018/execute",
                GEO09E01_CS_FRA : QUERY_SERVICES_URL + "/Query_GEO09E01_CS_FRA/execute",
                GEO09E02_CS_ANG : QUERY_SERVICES_URL + "/Query_GEO09E02_CS_ANG/execute",
                GEO09E03_CS_STA : QUERY_SERVICES_URL + "/Query_GEO09E03_CS_STA/execute"
            },
            SEARCH_VIEW: {
                GEOCODER_CP: GEOCODER_MSP_URL,
                GEOCODER_ADRS: GEOCODER_MSP_URL,
            }
        },
        LAYERS : {
            GEOCODER_CP : require("configs/layers/GEOCODER_CP"),
            GEOCODER_ADRS: require("configs/layers/GEOCODER_ADRS")
        },
        THEMESETS_ELEMENTS: { },
        APP_TOOLS: {
            CLIENT_ERRORS_LOGGER: {
                ENABLE: true
            },
            GUIDED_TOUR: require("configs/appTools/GuidedTourConfig"),
            ZOOM_LAYERING: require("configs/appTools/ZoomLayeringConfig")
        },
        MAP_TOOLS: {
            BASEMAP_TOGGLE: [
                {ID: "carte", BASEMAPLAYERS_IDS: ["Fondstuiles_5"], INITIAL: true, COPYRIGHTS_IMAGERIE: false},
                {ID: "hybride", BASEMAPLAYERS_IDS: ["Fondstuiles_5", "Fondstuiles_7"], INITIAL: false, COPYRIGHTS_IMAGERIE: true},
                {ID: "imagerie", BASEMAPLAYERS_IDS: ["Fondstuiles_7"], INITIAL: false, COPYRIGHTS_IMAGERIE: true}
            ],
            FORAGE: require("configs/mapTools/ForageConfig"),
            TOGGLE_YEARS: require("configs/mapTools/ToggleYearsConfig"),
        },
        PANELS: {
            CONSTAT: require("configs/panels/ConstatConfig")
        },
        MAP: {
            ID: "map1"
        },
        DEBUG: SERVER === "DEV" ? true : false
    };
});
